"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 7h-8v6h8zm-2 4h-4V9h4z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M13 9h4v2h-4z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2m0 16.01H3V4.98h18z"
}, "2")], 'PictureInPictureTwoTone');